import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, DownloadIcon, SmartphoneIcon } from 'lucide-react';
import { Reveal, Eyebrow } from './Section';
import { IMAGES } from './constants';
const points = [{
  icon: BookOpenIcon,
  label: '8 módulos + 3 bonos'
}, {
  icon: SmartphoneIcon,
  label: 'Leelo desde el celular'
}, {
  icon: DownloadIcon,
  label: 'Descarga inmediata'
}];
export function ProductPreview() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-166" data-mp="1br8ysyaruu9k">
      <div className="mx-auto max-w-5xl px-5 text-center sm:px-6" data-id="element-167" data-mp="1gqbtbot4li3a">
        <Reveal data-id="element-168" data-mp="1goio8dy5v5xe">
          <Eyebrow data-id="element-169" data-mp="1lhtx0kmj9wry">Así se ve por dentro</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-plum sm:text-4xl" data-id="element-170" data-mp="1li3pcev1wg0t">
            Un ebook diseñado para leerse y aplicarse
          </h2>
        </Reveal>

        <Reveal delay={0.1} data-id="element-171" data-mp="1ujkzlgls1nhl">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative mx-auto mt-12 max-w-xl" data-id="element-172" data-mp="1ug5loh3uakhr">
            <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-br from-rose-soft to-gold-soft/50" data-id="element-173" data-mp="oqxutsib3j8g" />
            <img src={IMAGES.preview} alt="El ebook Tus primeros USD 1.000 con contenido UGC y sus bonos incluidos" className="relative aspect-[4/5] w-full rounded-[1.6rem] object-cover shadow-soft" data-id="element-174" data-mp="kqe354gi57tp" />
          </motion.div>
        </Reveal>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4" data-id="element-175" data-mp="18g8aj6i1y46k">
          {points.map(p => <div key={p.label} className="flex items-center gap-2 rounded-full border border-sand bg-white px-5 py-2.5 text-sm font-medium text-plum shadow-card" data-id="element-176" data-mp="13mvo930ui9gz">
              <p.icon className="h-4 w-4 text-coral" data-id="element-177" data-mp="1w74160arutc8" />
              {p.label}
            </div>)}
        </div>
      </div>
    </section>;
}